/* coming-soon.js — vanilla JS countdown, no dependencies */
(function () {
  'use strict';

  function initCountdown(root) {
    var wrap = root.querySelector('[data-countdown]');
    if (!wrap) return;

    var dateStr = root.getAttribute('data-launch-date'); // e.g. 2026-12-31
    var timeStr = root.getAttribute('data-launch-time') || '00:00'; // e.g. 09:00

    if (!dateStr) return;

    // Built as a local-time Date in the visitor's own browser time zone,
    // which is the closest a client-side countdown can get to "correct
    // everywhere" without a fixed store time zone offset.
    var target = new Date(dateStr + 'T' + timeStr + ':00');

    if (isNaN(target.getTime())) return;

    var daysEl = wrap.querySelector('[data-days]');
    var hoursEl = wrap.querySelector('[data-hours]');
    var minsEl = wrap.querySelector('[data-minutes]');
    var secsEl = wrap.querySelector('[data-seconds]');

    var intervalId = null;

    function pad(n) {
      return String(n).length < 2 ? '0' + n : String(n);
    }

    function render() {
      var now = new Date();
      var diff = target.getTime() - now.getTime();

      if (diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minsEl.textContent = '00';
        secsEl.textContent = '00';
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
        wrap.dispatchEvent(new CustomEvent('coming-soon:complete'));
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minsEl.textContent = pad(minutes);
      secsEl.textContent = pad(seconds);
    }

    render();
    intervalId = setInterval(render, 1000);

    // Clean up if the theme editor re-renders this section instance.
    root.__comingSoonCleanup = function () {
      if (intervalId) clearInterval(intervalId);
    };
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-coming-soon]');
    sections.forEach(function (el) {
      if (typeof el.__comingSoonCleanup === 'function') {
        el.__comingSoonCleanup();
      }
      initCountdown(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support: re-init when this section is loaded/reordered.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-coming-soon]');
    if (el) initCountdown(el);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector('[data-coming-soon]');
    if (el && typeof el.__comingSoonCleanup === 'function') {
      el.__comingSoonCleanup();
    }
  });
})();
